import { memo } from 'react';
import { Button } from '@mui/material';

import ShaxmatkaEntranceTooltip from './ShaxmatkaEntranceTooltip';
import BaseTooltip from 'components/ui/tooltips/BaseTooltip';
import { useTranslation } from 'react-i18next';
import VisualZoomBox from './VisualZoomBox';

const EntrancesView = ({
  data = {},
  selectedBlock = '',
  onClickPolygonFn = () => {},
  backFn = () => {},
}) => {
  const { t } = useTranslation();
  const getPolygonPoints = (coordinates) => {
    return JSON.parse(coordinates)
      .flat(2)
      .map((item) => (item * 72).toFixed(3))
      .join();
  };

  return (
    <div className='shaxmatka-visual-view-wrapper !h-full'>
      <div className='visual-view-header'>
        <div className='visual-view-back-btn-wrapper'>
          <BaseTooltip title={t('common.button.back')} arrow placement='bottom'>
            <Button variant='action' color='primary' onClick={() => backFn()}>
              <i className='bi bi-arrow-left flex items-center justify-center' />
            </Button>
          </BaseTooltip>
        </div>

        <div className='visual-view-title'>{selectedBlock?.name || ''}</div>
      </div>

      <VisualZoomBox>
        <div className='visual-view-body h-full items-center w-full'>
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/${data?.image}`}
            alt=''
            className='helper-image'
          />
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/${data?.image}`}
            alt=''
            className='main-image !h-full !w-full'
            id='main-image'
          />
          <svg
            viewBox={`0 0 ${data?.width} ${data?.height}`}
            xmlns='http://www.w3.org/2000/svg'
            className='svg-item block-svg-polygons'
          >
            {data.padezd &&
              data.padezd.length > 0 &&
              data.padezd.map((padezd, index) => (
                <ShaxmatkaEntranceTooltip
                  key={`block-polygon-${index}`}
                  padezd={padezd}
                >
                  <polygon
                    key={`block-polygon-${index}`}
                    points={getPolygonPoints(padezd?.cordinates)}
                    fillOpacity='0.3'
                    style={{
                      transform: `scaleY(-1) translateY(-${
                        +data?.height + 10
                      }px)`,
                    }}
                    className='block-polygon'
                    onClick={() => onClickPolygonFn(padezd)}
                    id={`block-entrance-${selectedBlock?.id}-polygon`}
                  />
                </ShaxmatkaEntranceTooltip>
              ))}
          </svg>
        </div>
      </VisualZoomBox>
    </div>
  );
};
export default memo(EntrancesView);
